import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import { Amplify } from "aws-amplify";
import outputs from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";
import { Authenticator } from "@aws-amplify/ui-react";
import * as amplitude from "@amplitude/analytics-browser";
import { initAmplitude, useAmplitudeTracking } from "./Tools/Tools";
import { HelmetProvider } from "react-helmet-async";

// Configure AWS Amplify
Amplify.configure(outputs);
initAmplitude("54a3b43f25bf4df60a1ae29ed81c22d8");

// Create a root for ReactDOM
const rootElement = document.getElementById("root") as HTMLElement;
const root = createRoot(rootElement);

// Render the application
root.render(
  <React.StrictMode>
    <Authenticator.Provider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </PersistGate>
      </Provider>
    </Authenticator.Provider>
  </React.StrictMode>
);

reportWebVitals();
